import { client } from '../api/client';
import { BanksPage, BanksQuery, IBankService, PaginationOptions } from './interfaces/bank.interface';
import { AxiosResponse } from 'axios';

const DEFAULT_PAGINATION_OPTIONS: PaginationOptions = {
	paginationSize: 10,
	paginationOffset: 0
};

class BankService implements IBankService {
	async fetchBanks(query: BanksQuery = DEFAULT_PAGINATION_OPTIONS): Promise<BanksPage> {
		const banksQuery = this.createBanksQuery(query);
		const response: AxiosResponse<BanksPage> = await client.post('/institutions', banksQuery);
		return response.data;
	}

	private createBanksQuery(query: BanksQuery): BanksQuery {
		const searchTerm = this.getSearchTerm(query.searchTerm);
		return {
			...DEFAULT_PAGINATION_OPTIONS,
			...query,
			searchTerm
		};
	}

	private getSearchTerm(search: string | undefined): string | undefined {
		return search !== '' ? search : undefined;
	}
}

export const bankService = new BankService();

export default bankService;
